import { render, staticRenderFns } from "./GroupShareOptions.vue?vue&type=template&id=ed0ebb24"
import script from "./GroupShareOptions.vue?vue&type=script&lang=js"
export * from "./GroupShareOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports